import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Trans } from 'app/lang';

import Error from '../EntryComponents/Error';

import dictionary from './NoMoneyLink.dictionary.json';

import styles from './NoMoneyLink.module.scss';

// ---

type NoMoneyLinkProps = {
  className?: string;
};

const NoMoneyLink: FC<NoMoneyLinkProps> = ({ className }) => {
  const message = (
    <Trans data={dictionary.message}
           components={{
             ref: (
               <Link to="/personal/deposit"
                     data-test="noMoneyLink-link"
                     data-ga-event="depositStart"
                     data-ga-event-value="cartClick"
                     className={styles.link} />
             ),
           }} />
  );

  return (
    <Error message={message}
           data-test="noMoneyLink-error"
           className={className} />
  );
};

export default NoMoneyLink;
